import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Calendrier from './components/calendrier';
import Reservation from './components/reservations';
import Chambre from './components/chambres';
import Connexion from './components/connexion/connexion';
import ProtectedRoute from './components/connexion/ProtectedRoute';
import {AuthProvider} from './components/connexion/useAuth';

function App() {
  return (
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.js</code>.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>

     <Router>
      <AuthProvider>
        <Routes>
          <Route path='/' element={<Connexion />} />
          {/* ✅ Routes protégées */}
          <Route path="/Calendrier" element={
            <ProtectedRoute>
              <Calendrier />
            </ProtectedRoute>
          } />
          <Route path="/liste-reservations" element={
            <ProtectedRoute>
              <Reservation />
            </ProtectedRoute>
          } />
          <Route path="/liste-chambres" element={
            <ProtectedRoute>
              <Chambre />
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </Router>

  );
}

export default App;
